// Types - Read Models
import { type TeacherDashboardReadModel } from '@c1/dashboard.types.read-models';

export default defineNuxtRouteMiddleware(async (to) => {
  const schoolsStore = useTeacherSchoolsStore();
  // Boolean flag to check if the store is loaded
  const bfetchSchoolsFromServer = !schoolsStore.isLoaded;

  if (bfetchSchoolsFromServer) {
    //Fetch data from API
    const { data } = await useFetchHelper().fetch<
      TeacherDashboardReadModel['schools']
    >('/api/schools', {
      fatal: true,
      errorHandlingStrategy: 'showErrorPage' // Show error page if API fails
    });
    schoolsStore.load({ schools: data.value });
  }
  // Check if the number of visible schools is greater than 0
  if (countVisibleSchools(schoolsStore.schools) > 0) {
    // If the query parameter 'joinAnotherInstitute' is set to 'true'
    if (to.query.joinAnotherInstitute === 'true') {
      // Allow the navigation to proceed (return true)
      return true;
    } else {
      // Otherwise, navigate to the 'joinSchool' page with the query parameter set
      return navigateTo({
        path: '/teacher/startteaching/joinSchool',
        query: { joinAnotherInstitute: true }
      });
    }
  } else {
    // If there are no visible schools and 'joinAnotherInstitute' is 'true'
    if (to.query.joinAnotherInstitute === 'true') {
      // Navigate to the 'joinSchool' page without any query parameters
      return navigateTo(['/teacher/startteaching/joinSchool']);
    }
    // Otherwise, allow the navigation to proceed (return true)

    return true;
  }
});

/**
 * This function is used to determine how many schools are considered "visible" based on the presence and value of a visiblity property.
 * If a school does not explicitly specify its visibility as false, it is counted as visible.
 * @param schools - list of schools
 * @returns count of visible schools
 *
 */
function countVisibleSchools(schools) {
  let count = 0;
  for (const key in schools) {
    if (
      schools[key].school?.privateSchoolSpecification
        ?.isSchoolSetupIncomplete !== true
    ) {
      count++;
    }
  }
  return count;
}
